import { PICKED_VIDEO_FILE } from "../actionTypes";
import { videoSavedState } from "../initialState";

export const videoSavedReducer = (state = videoSavedState, action) => {
  switch (action.type) {
    case PICKED_VIDEO_FILE:
      return {
        ...state,
        pickedVideofile: action.payload,
      };
    default:
      return state;
  }
};
